import Settings from "./Settings";
import { AuthToken } from "./AuthToken";

import ProcessingResult from "../framework/ProcessingResult";

import AIGroupDto from "../classes/dtos/assistantmodule/AIGroupDto";
import AIGroupPathDto from "../classes/dtos/assistantmodule/AIGroupPathDto";
import AIGroupUserDto from "../classes/dtos/assistantmodule/AIGroupUserDto";

const AIGroupApi = {

    GetAllAIGroupSettingsAsync: async function (): Promise<ProcessingResult<AIGroupDto[]>> {
        let authSession = await AuthToken.get();

        const response = await fetch(Settings.api_url + "/AIGroup/GetAllAIGroupSettings", {
            method: "GET",
            mode: "cors",
            cache: "no-cache",
            credentials: 'include',
            headers: {
                "Content-Type": "application/json",
                "Authorization": "Bearer " + authSession.Token
            }
        });

        if (response.status === 200) {
            let data = await response.json();

            let result = data.aiGroups.map((e: any) => {
                return new AIGroupDto(
                    e.aiGroupId,
                    e.name,
                    e.paths.map((f: any) => { return new AIGroupPathDto(e.aiGroupId, f.aiGroupPathId, f.pathId, f.pathName); }),
                    e.users.map((f: any) => { return new AIGroupUserDto(f.aiGroupUserId, f.userId); })
                );
            });

            return ProcessingResult.Ok<AIGroupDto[]>(result);
        }

        return ProcessingResult.Error("Error = " + response.status.toString());
    },

    CreateAIGroupAsync: async function (name: string, userIds: number[]): Promise<ProcessingResult<number>> {
        let authSession = await AuthToken.get();

        const response = await fetch(Settings.api_url + "/AIGroup/CreateAIGroup", {
            method: "POST",
            mode: "cors",
            cache: "no-cache",
            credentials: 'include',
            headers: {
                "Content-Type": "application/json",
                "Authorization": "Bearer " + authSession.Token
            },
            body: JSON.stringify({
                'name': name,
                'userIds': userIds
            })
        });

        if (response.status === 200) {
            let data = await response.json();
            return ProcessingResult.Ok(data.id);
        }

        return ProcessingResult.Error("Error = " + response.status.toString());
    },

    UpdateAIGroupAsync: async function (aiGroupId: number, name: string, userIds: number[]): Promise<ProcessingResult<boolean>> {
        let authSession = await AuthToken.get();

        const response = await fetch(Settings.api_url + "/AIGroup/UpdateAIGroup", {
            method: "PUT",
            mode: "cors",
            cache: "no-cache",
            credentials: 'include',
            headers: {
                "Content-Type": "application/json",
                "Authorization": "Bearer " + authSession.Token
            },
            body: JSON.stringify({
                'aiGroupId': aiGroupId,
                'name': name,
                'userIds': userIds
            })
        });

        if (response.status === 200) {
            return ProcessingResult.Ok(true);
        }

        return ProcessingResult.Error("Error = " + response.status.toString());
    },

    DeleteAIGroupAsync: async function (aiGroupId: number): Promise<ProcessingResult<boolean>> {
        let authSession = await AuthToken.get();

        const response = await fetch(Settings.api_url + "/AIGroup/DeleteAIGroup?id=" + aiGroupId, {
            method: "DELETE",
            mode: "cors",
            cache: "no-cache",
            credentials: 'include',
            headers: {
                "Content-Type": "application/json",
                "Authorization": "Bearer " + authSession.Token
            }
        });

        if (response.status === 200) {
            return ProcessingResult.Ok(true);
        }

        return ProcessingResult.Error("Error = " + response.status.toString());
    },

    CreateAIGroupPathAsync: async function (aiGroupId: number, pathId: number): Promise<ProcessingResult<number>> {
        let authSession = await AuthToken.get();

        const response = await fetch(Settings.api_url + "/AIGroup/CreateAIGroupPath", {
            method: "POST",
            mode: "cors",
            cache: "no-cache",
            credentials: 'include',
            headers: {
                "Content-Type": "application/json",
                "Authorization": "Bearer " + authSession.Token
            },
            body: JSON.stringify({
                'aiGroupId': aiGroupId,
                'pathId': pathId
            })
        });

        if (response.status === 200) {
            let data = await response.json();
            return ProcessingResult.Ok(data.id);
        }

        return ProcessingResult.Error("Error = " + response.status.toString());
    },

    UpdateAIGroupPathAsync: async function (aiGroupPathId: number, aiGroupId: number, pathId: number): Promise<ProcessingResult<boolean>> {
        let authSession = await AuthToken.get();

        const response = await fetch(Settings.api_url + "/AIGroup/UpdateAIGroupPath", {
            method: "PUT",
            mode: "cors",
            cache: "no-cache",
            credentials: 'include',
            headers: {
                "Content-Type": "application/json",
                "Authorization": "Bearer " + authSession.Token
            },
            body: JSON.stringify({
                'aiGroupPathId': aiGroupPathId,
                'aiGroupId': aiGroupId,
                'pathId': pathId
            })
        });

        if (response.status === 200) {
            return ProcessingResult.Ok(true);
        }

        return ProcessingResult.Error("Error = " + response.status.toString());
    },

    DeleteAIGroupPathAsync: async function (aiGroupPathId: number): Promise<ProcessingResult<boolean>> {
        let authSession = await AuthToken.get();

        const response = await fetch(Settings.api_url + "/AIGroup/DeleteAIGroupPath?id=" + aiGroupPathId, {
            method: "DELETE",
            mode: "cors",
            cache: "no-cache",
            credentials: 'include',
            headers: {
                "Content-Type": "application/json",
                "Authorization": "Bearer " + authSession.Token
            }
        });

        if (response.status === 200) {
            return ProcessingResult.Ok(true);
        }

        return ProcessingResult.Error("Error = " + response.status.toString());
    }
};

export default AIGroupApi;
